import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import { startDirection, endDirection } from 'app/styles/selectors/markup';

const { widthSmallExtended, widthMedium, widthSmall } = breakpoints;
const S = {};

S.OfflineViewingBlock = {};

S.OfflineViewingBlock.Title = styled.h2`
  label: Title;

  margin-bottom: 1rem;
`;

S.OfflineViewingBlock.Wrapper = styled.div`
  label: Wrapper;

  background-color: var(--colors-alabaster);
  display: flex;
  flex-direction: column;

  @media (${widthSmallExtended}) {
    flex-direction: row-reverse;
  }
`;

S.OfflineViewingBlock.Content = styled.div`
  label: Content;

  display: flex;
  flex-direction: column;
  padding: 2.5rem 1.25rem;

  @media (${widthSmallExtended}) {
    padding-top: 3.125rem;
    padding-${endDirection}: 1.25rem;
    padding-bottom: 2.5rem;
    padding-${startDirection}: 2.5rem;
    min-width: 25.75rem;
    width: 25.75rem;
  }

  @media (${widthMedium}) {
    padding-top: 3.375rem;
    padding-${endDirection}: 1.875rem;
    min-width: 32.5rem;
    width: 32.5rem;
  }
`;

S.OfflineViewingBlock.Subtitle = styled.h3`
  label: Subtitle;

  margin-bottom: 1.25rem;
  text-align: center;

  @media (${widthSmallExtended}) {
    text-align: initial;
  }
`;

S.OfflineViewingBlock.Description = styled.p`
  label: Description;

  margin-bottom: 2.5rem;
  text-align: center;

  @media (${widthSmallExtended}) {
    text-align: initial;
  }
`;

S.OfflineViewingBlock.ButtonsWrapper = styled.div`
  label: ButtonsWrapper;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  a:first-of-type {
    margin-bottom: 1.25rem;
  }

  @media (${widthSmallExtended}) {
    flex-direction: row;
    width: auto;

    a:first-of-type {
      margin-${endDirection}: 1.25rem;
      margin-bottom: 0;
    }
  }
`;

S.OfflineViewingBlock.ImageWrapper = styled.div`
  label: ImageWrapper;

  width: 100%;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
`;

S.OfflineViewingBlock.BackgroundImage = styled.img`
  label: BackgroundImage;

  width: 115%;
  height: 8.75rem;
  object-fit: cover;
  object-position: bottom;

  @media (${widthSmall}) {
    height: 10.25rem;
  }

  @media (${widthSmallExtended}) {
    object-position: ${startDirection};
    height: auto;
    width: 100%;
  }
`;

S.OfflineViewingBlock.NativeAppImage = styled.img`
  label: NativeAppImage;

  display: block;
`;

export default S;
